<template>
  <a-modal
    :visible="visible"
    :width="960"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    centered
  >
    <template slot="title">
      <span style="font-size: 18px; font-weight: 800">状态变更</span>
      <a-button type="primary" size="small" style="margin-left: 12px; margin-top: -4px; top: -1px">
        {{ exceptionCode }}
      </a-button>
    </template>
    <a-form-model :layout="layout" :model="form" :rules="rules" ref="form1">
      <a-form-model-item label="状态变更为" prop="solveStatus">
        <a-select allowClear v-model="form.solveStatus" style="width: 100%">
          <a-select-option :value="0">已忽略</a-select-option>
          <a-select-option :value="1"> 待处理</a-select-option>
          <a-select-option :value="2"> 已处理</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="处理过程描述" prop="remark">
        <a-textarea
          :rows="12"
          v-model="form.remark"
          placeholder="请输入处理步骤和处理方法"
          :maxLength="500"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { modifystatus, status } from '@/api/Monitor/abnormal'
export default {
  data() {
    return {
      confirmLoading: false,
      visible: false,
      exceptionCode: '',
      layout: 'horizontal',
      form: {
        remark: undefined,
        solveStatus: undefined
      },
      rules: {
        solveStatus: [{ required: true, message: '请选择处理状态', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入说明', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      }
    }
  },
  methods: {
    showModel(record) {
      this.visible = true
      this.exceptionCode = record.exceptionCode
      this.form = { solveStatus: undefined, remark: undefined }
      this.form.id = record.id
      this.form.monitorId = record.monitorId
      status(record.id).then((res) => {
        const { extra } = res
        this.form.solveStatus = extra.status.nextSolveStatus
        this.form.remark = extra.status.remark
      })
    },
    handleOk(e) {
      // this.ModalText = 'The modal will be closed after two seconds'
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          modifystatus(this.form).then((res) => {
            this.confirmLoading = false
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.visible = false
              setTimeout(() => {
                this.$emit('reload')
              }, 400)
            } else {
              this.$message.error(res.msg)
            }
          })
          //   this.visible = false
          //   this.confirmLoading = false
        }
      })

      // setTimeout(() => {
      //   this.visible = false
      //   this.confirmLoading = false
      // }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>

<style></style>
